import React from 'react';
import ModernNode from './ModernNode';
import { NODE_TYPES } from '../../config/nodeConfig';

const TemplateNode = (props) => {
  return <ModernNode {...props} nodeType={NODE_TYPES.TEMPLATE} />;
};

export default TemplateNode;